import * as template from './user.hbs';
import Component from '../component/component';
import TidingsClient from './tidingsClient';
import 'bootstrap/dist/css/bootstrap.css';

class ViewModel {
    userName: string;
    isAccessAllowed: boolean;
}

export default class User extends Component<ViewModel> {

    constructor(private tidingsClient: TidingsClient) {
        super(template, new ViewModel());

        this.tidingsClient.getUserInfo().then(userInfo => {
            this.viewModel.isAccessAllowed = userInfo.IsAccessAllowed;
            this.viewModel.userName = userInfo.Name;
            this.refresh();
        });

    }

    bind(element: Element, model: ViewModel): void {
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/Tidings/user.ts